export default [
  {
    component: 'CNavItem',
    name: 'Home',
    to: '/home',
    icon: 'cil-home',
    // badge: {
    //   color: 'primary',
    //   text: 'NEW',
    // },
  },
  {
    component: 'CNavTitle',
    name: 'Universitário por um dia',
    rule: 'up1d',
  },
  {
    component: 'CNavGroup',
    name: 'Agendamentos',
    icon: 'cil-calendar',
    rule: 'up1d',
    items: [
      {
        component: 'CNavItem',
        name: 'Calendário',
        to: '/agendamento/calendario',
      },
      {
        component: 'CNavItem',
        name: 'Visitas',
        to: '/agendamento/lista',
      },
    ],
  },
  {
    component: 'CNavItem',
    name: 'Escolas',
    to: '/escolas',
    rule: 'up1d',
    icon: 'cilBuilding',
  },
  {
    component: 'CNavGroup', name: 'Formulários', icon: 'cilList', rule: 'up1d',
    items: [
      { component: 'CNavItem', name: 'Socioeconômico', to: '/formularios/socioeconomico' },
      { component: 'CNavItem', name: 'Pesquisa dos alunos', to: '/formularios/alunos' },
      { component: 'CNavItem', name: 'Pesquisa dos professores', to: '/formularios/professores' },
    ],
  },
  {
    component: 'CNavTitle',
    name: 'CUCO',
    rule: 'cuco',
  },
  {
    component: 'CNavItem',
    name: 'Alunos',
    to: '/cuco/alunos',
    rule: 'cuco',
    icon: 'cilGroup',
  },
  {
    component: 'CNavGroup',
    name: 'Colaboradores',
    icon: 'cilSchool',
    rule: 'cuco',
    items: [
      {
        component: 'CNavItem',
        name: 'Diretores de Ensino',
        to: '/cuco/colaboradores/de/lista',
      },
      {
        component: 'CNavItem',
        name: 'Professores',
        to: '/cuco/colaboradores/professores/lista',
      },
    ],
  },

  {
    component: 'CNavGroup',
    name: 'Edições',
    icon: 'cilLibrary',
    rule: 'cuco',
    items: [
      {
        component: 'CNavItem',
        name: 'CUCO 2023',
        to: '/cuco/edicoes/cuco-23',
      },
      {
        component: 'CNavItem',
        name: 'CUCO 2024',
        to: '/cuco/edicoes/cuco-24',
      },
      {
        component: 'CNavItem',
        name: 'CUCO 2025',
        to: '/cuco/edicoes/cuco-25',
      },
    ],
  },
  {
    component: 'CNavItem',
    name: 'Banco de Questões',
    to: '/cuco/questoes',
    rule: 'cuco',
    icon: 'cilFolderOpen',
  },
  {
    component: 'CNavTitle',
    name: 'Ferramentas',
    rule: 'ferramentas',
  },
  {
    component: 'CNavGroup',
    name: 'E-mails',
    icon: 'cilEnvelopeClosed',
    rule: 'ferramentas',
    items: [
      {
        component: 'CNavItem',
        name: 'Envios',
        to: '/emails/lista',
      },
      {
        component: 'CNavItem',
        name: 'Modelos',
        to: '/emails/modelos/lista',
      },
    ],
  },
  {
    component: 'CNavTitle',
    name: 'ADM',
    superAdm: true,
  },
  {
    component: 'CNavItem',
    name: 'Administradores',
    to: '/adm',
    superAdm: true,
    icon: 'cilContact',
  },
  // {
  //   component: 'CNavItem',
  //   name: 'Colaboradores',
  //   to: '/cuco/colaboradores/lista',
  //   icon: 'cilGroup',
  // },
  // {
  //   component: 'CNavItem',
  //   name: 'Participantes',
  //   to: '/participantes/lista',
  //   icon: 'cilPeople',
  // },
  // {
  //   component: 'CNavItem',
  //   name: 'Typography',
  //   to: '/theme/typography',
  //   icon: 'cil-pencil',
  // },
  // {
  //   component: 'CNavTitle',
  //   name: 'Components',
  // },
  // {
  //   component: 'CNavGroup',
  //   name: 'Base',
  //   to: '/base',
  //   icon: 'cil-puzzle',
  //   items: [
  //     {
  //       component: 'CNavItem',
  //       name: 'Accordion',
  //       to: '/base/accordion',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Breadcrumbs',
  //       to: '/base/breadcrumbs',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Cards',
  //       to: '/base/cards',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Carousels',
  //       to: '/base/carousels',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Collapses',
  //       to: '/base/collapses',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'List Groups',
  //       to: '/base/list-groups',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Navs & Tabs',
  //       to: '/base/navs',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Paginations',
  //       to: '/base/paginations',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Placeholders',
  //       to: '/base/placeholders',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Popovers',
  //       to: '/base/popovers',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Progress',
  //       to: '/base/progress',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Spinners',
  //       to: '/base/spinners',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Tables',
  //       to: '/base/tables',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Tooltips',
  //       to: '/base/tooltips',
  //     },
  //   ],
  // },
  // {
  //   component: 'CNavGroup',
  //   name: 'Buttons',
  //   to: '/buttons',
  //   icon: 'cil-cursor',
  //   items: [
  //     {
  //       component: 'CNavItem',
  //       name: 'Buttons',
  //       to: '/buttons/standard-buttons',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Button Groups',
  //       to: '/buttons/button-groups',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Dropdowns',
  //       to: '/buttons/dropdowns',
  //     },
  //   ],
  // },
  // {
  //   component: 'CNavGroup',
  //   name: 'Forms',
  //   to: '/forms',
  //   icon: 'cil-notes',
  //   items: [
  //     {
  //       component: 'CNavItem',
  //       name: 'Form Control',
  //       to: '/forms/form-control',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Select',
  //       to: '/forms/select',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Checks & Radios',
  //       to: '/forms/checks-radios',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Range',
  //       to: '/forms/range',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Input Group',
  //       to: '/forms/input-group',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Floating Labels',
  //       to: '/forms/floating-labels',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Layout',
  //       to: '/forms/layout',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Validation',
  //       to: '/forms/validation',
  //     },
  //   ],
  // },
  // {
  //   component: 'CNavItem',
  //   name: 'Charts',
  //   to: '/charts',
  //   icon: 'cil-chart-pie',
  // },
  // {
  //   component: 'CNavGroup',
  //   name: 'Icons',
  //   to: '/icons',
  //   icon: 'cil-star',
  //   items: [
  //     {
  //       component: 'CNavItem',
  //       name: 'CoreUI Icons',
  //       to: '/icons/coreui-icons',
  //       badge: {
  //         color: 'info',
  //         text: 'NEW',
  //       },
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Brands',
  //       to: '/icons/brands',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Flags',
  //       to: '/icons/flags',
  //     },
  //   ],
  // },
  // {
  //   component: 'CNavGroup',
  //   name: 'Notifications',
  //   to: '/notifications',
  //   icon: 'cil-bell',
  //   items: [
  //     {
  //       component: 'CNavItem',
  //       name: 'Alerts',
  //       to: '/notifications/alerts',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Badges',
  //       to: '/notifications/badges',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Modals',
  //       to: '/notifications/modals',
  //     },
  //   ],
  // },
  // {
  //   component: 'CNavItem',
  //   name: 'Widgets',
  //   to: '/widgets',
  //   icon: 'cil-calculator',
  //   badge: {
  //     color: 'primary',
  //     text: 'NEW',
  //     shape: 'pill',
  //   },
  // },
  // {
  //   component: 'CNavTitle',
  //   name: 'Extras',
  // },
  // {
  //   component: 'CNavGroup',
  //   name: 'Pages',
  //   to: '/pages',
  //   icon: 'cil-star',
  //   items: [
  //     {
  //       component: 'CNavItem',
  //       name: 'Login',
  //       to: '/pages/login',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Register',
  //       to: '/pages/register',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Error 404',
  //       to: '/pages/404',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Error 500',
  //       to: '/pages/500',
  //     },
  //   ],
  // },

  // {
  //   component: 'CNavItem',
  //   name: 'Download CoreUI',
  //   href: 'http://coreui.io/vue/',
  //   icon: { name: 'cil-cloud-download', class: 'text-white' },
  //   _class: 'bg-success text-white',
  //   target: '_blank'
  // },
  // {
  //   component: 'CNavItem',
  //   name: 'Try CoreUI PRO',
  //   href: 'http://coreui.io/pro/vue/',
  //   icon: { name: 'cil-layers', class: 'text-white' },
  //   _class: 'bg-danger text-white',
  //   target: '_blank'
  // }
]
